module.exports = __webpack_public_path__ + "static/4.3_early_empires-eb4bfceefa7aeca6e6bce25d60bcb836.pdf";